import React, { FC } from 'react';
import { graphql } from 'gatsby';
import { PageHeaderFragment } from '../../types/graphqlTypes';
import { Hero } from './hero/Hero';
import { SimplePageHeader } from './SimplePageHeader';

interface PageHeaderProps {
  pageHeader: PageHeaderFragment;
}

export const PageHeader: FC<PageHeaderProps> = ({ pageHeader }) => (
  <>
    {pageHeader && (
      <>
        {pageHeader.remoteTypeName === 'UmbracoHeroType' && (
          <Hero
            heading={pageHeader.title}
            lead={pageHeader.lead}
            backgroundImage={pageHeader.image?.localFile}
            mobileBackgroundImage={pageHeader.mobileImage?.localFile}
            tabletBackgroundImage={pageHeader.tabletImage?.localFile}
            component={pageHeader?.component}
            trustpilot={pageHeader.trustpilot}
            showReviewCount
          />
        )}

        {pageHeader.remoteTypeName === 'UmbracoBasePageHeaderType' && (
          <SimplePageHeader title={pageHeader.title} lead={pageHeader.lead} hasDivider />
        )}
      </>
    )}
  </>
);

export const PageHeaderQuery = graphql`
  fragment PageHeader on KFH_UmbracoPageHeader {
    remoteTypeName
    ...Hero
    ...SimplePageHeader
  }
`;
